module.exports = __webpack_public_path__ + "img/logo-gudings.4677d306.png";